module.exports = __webpack_public_path__ + "img/logo.5cab4edc.png";